module.exports = __webpack_public_path__ + "c8f4c435158d3513edae1cef21bb1240.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-scopely.png
// module id = 638
// module chunks = 0